<div class="estimate-download-mainpage">
  <div class="container">

    <!-- Top Header -->
    <div class="top-bar">
      <div class="logo-title">
        <!-- <span class="logo">Autoverse</span> -->
        <span class="title">Service Estimate</span>
      </div>
      <div class="powered">🔷 Powered by Autoverse</div>
    </div>

    <!-- Meta Info -->
    <!-- <div class="meta-info">
      <div class="estimate-id">
        <div class="estimate-id-txt">Estimate ID: </div>
        <div class="est-actual-id">EST-2024-001</div></div>
      <div class="estimate-id">
        <div class="estimate-id-txt">Date: </div>
        <div class="est-actual-id">15 Jan 2024</div></div>
        <div class="estimate-id">
        <div class="estimate-id-txt">Validity:</div>
        <div class="est-actual-id">30 days</div></div>
       <div class="estimate-id">
        <div class="estimate-id-txt">Status:</div>
        <div class="status draft">Draft</div></div>
    </div> -->

    <!-- Details Section -->
    <div class="details-section">
      <div class="card">
          <h3>Garage Details</h3>
          <div class="name">{{ garageName }}</div>
          <div class="phone-and-email">{{ garageContact }}</div>
          <div class="location">{{ garageLocation }}</div>
      </div>
      <div class="card">
        <h3>Vehicle Details</h3>
        <div class="reg-number">🚘 Reg: {{ regNumber }}</div>
        <div class="car-info">🚗 {{ selectedMake }} {{ selectedModel }} • {{ selectedYear }} • {{ fuelType }} • {{ variant }}</div>
        <div class="tags">
          <span class="tag verified">✅ Verified</span>
          <span class="tag time">⏱️ 2–3 Hours</span>
        </div>
      </div>
      <div class="card">
        <h3>Customer Details</h3>
        <div class="name">{{ customerNameDetail }}</div>
        <div class="phone-and-email">📞 {{ customerPhoneDetail }}</div>
      </div>
    </div>

    <!-- Feature Tags -->
    <div class="feature-tags">
      <span class="tag green">🛡️ Autoverse Assured</span>
      <span class="tag yellow">🔧 Genuine Parts</span>
      <span class="tag purple">🧾 Transparent Pricing</span>
      <span class="tag blue">📞 Warranty Support</span>
    </div>

    <!-- Estimated Total -->
    <div class="total-box">
      <div class="total-text">Estimated Total</div>
      <div class="amount">₹{{ estimatedTotal }}</div>
      <!-- <div class="subtext">Parts ₹6,020 • Labour ₹1,150 • Tax ₹1,291</div> -->
       <!-- <div class="subtext">✅ You save ₹1,870</div> -->
    </div>

        <!-- Parts Breakdown -->
   <!-- Parts Breakdown -->
    <div class="section">
      <h2>{{ serviceKitName }}</h2>
      <span class="main-tenence-class">Maintenance › Engine & Filters</span>
      <h3>Parts Breakdown</h3>
      <table class="breakdown">
        <thead>
          <tr>
            <th>Part</th>
            <th>Brand</th>
            <th>MRP (Unit)</th>
            <!-- <th>Qty</th>
            <th>MRP (Total)</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let part of partsInformation">
            <td>{{ part.partName }}</td>
            <td>{{ part.brandName }}</td>
            <td>₹{{ part.zohoPartPrice || '0' }}</td>
            <!-- <td>1</td>
            <td>₹{{ part.zohoPartPrice || '0' }}</td> -->
          </tr>
        </tbody>
      </table>
      <!-- <div class="subtotal">Parts Subtotal: <b>₹6,020</b></div> -->
      <div class="subtotal">Parts Subtotal: <b>₹{{ partsTotal }}</b></div>

      <!-- <div class="section"> -->
          <h3>Labour Breakdown</h3>
          <table class="breakdown-labour">
            <tbody>
              <tr *ngFor="let labour of laboursInformation">
                <td>{{ labour.labourName }}</td>
                <td>₹{{ labour.labourRate || '0' }}</td>
              </tr>
            </tbody>
          </table>

          <!-- <div class="subtotal-main">
            <div class="subtotal-labour">
              <div>Labour Subtotal: </div>
              <div>₹1,150</div>
            </div>
          </div> -->
          <div class="subtotal-main">
            <div class="subtotal-labour">
              <div>Labour Subtotal:</div>
              <div>₹{{ labourTotal }}</div>
            </div>
          </div>

          <!-- Service Subtotal -->
          <div class="highlight-box">
            <div class="service-header">Service Subtotal: ₹{{ estimatedTotal }}</div>
            <span class="note">Includes parts + labour. Taxes calculated in grand total.</span>
          </div>

        <!-- What's Included -->
          <div class="section-new">
            <h3>What’s Included</h3>
            <ul class="included">
               <li *ngFor="let item of whatsIncluded">{{ item }}</li>
            </ul>
          </div>
    </div>

<!-- Labour Breakdown -->
   

        <!-- Cost Summary -->
    <div class="cost-summary-box">
      <h3>Cost Summary</h3>
      <div class="summary-row">
        <span>Parts Subtotal</span>
        <span>₹{{ partsTotal }}</span>
      </div>
      <div class="summary-row">
        <span>Labour Subtotal</span>
        <span>₹{{ labourTotal }}</span>
      </div>
      <!-- <div class="summary-row savings">
        <span>Savings</span>
        <span>-₹1,870</span>
      </div> -->
      <!-- <div class="summary-row">
        <span>Tax (18% GST)</span>
        <span>₹1,291</span>
      </div> -->
      <!-- <div class="summary-total">
        <span>Estimated Total</span>
        <span class="total">₹8,461</span>
      </div> -->
      <div class="summary-total">
        <span>Estimated Total</span>
        <span class="total">₹{{ estimatedTotal }}</span>
      </div>

      <div class="note">Payment options available upon service confirmation</div>
    </div>

    <!-- Action Buttons -->
    <div class="actions">
      <!-- <button class="btn save">Save Estimate</button>
      <button class="btn share">Share</button> -->
      <button class="btn download" (click)="downloadPDF()" >Download PDF</button>
    </div>

    <!-- Footer Info -->
    <div class="footer-info">
      <div class="disclaimer">
        <h4>Disclaimer</h4>
        <p>This is an estimate based on your car’s registration and typical inclusions. 
        Final price may vary after inspection, selected brands, additional work, and taxes.</p>
      </div>
      <div class="contact">
        <h4>Contact</h4>
        <p>{{ garageName }}<br>
        +{{ garageContact }}<br>
        info@autocare.com<br>
        {{ garageLocation }}</p>
      </div>
    </div>

    <!-- Signatures -->
    <div class="signatures">
      <div class="sig-block">
        <h4>Customer Signature</h4>
        <div class="line">Name & Date</div>
      </div>
      <div class="sig-block">
        <h4>Garage Signature</h4>
        <div class="line">Authorized Signature</div>
      </div>
      <div class="sig-block verify">
        <h4>Verify Online</h4>
        <div class="qr">QR Code</div>
        <p class="verify-text">Scan to view or verify this estimate online</p>
      </div>
    </div>

  </div>
</div>



<app-loading *ngIf="loading"></app-loading>
